// extracted by mini-css-extract-plugin
export var container = "_dv-0";
export var icon = "_dv-1";
export var text = "_dv-2";